import { ButtonSecondaryV2, Modal } from "oolib";
import React from "react";
import { handleDataExport } from "../../../../utils/general";


export const DataDownloadModal = ({setExporting,getDataToBeExported, setShowDataDownloadModal}) => {
  
  const handleClick = ({dataFormat}) => {
    handleDataExport({getDataToBeExported, setExporting, dataFormat })
    setShowDataDownloadModal(false)
  }

  return (
    <Modal
      fitToContentHeight={true}
      desktopWidth="500px"
      onClose={() => setShowDataDownloadModal(false)} title="Choose a format"
    >
      <div style={{ display: "flex", gap: "1rem", padding: "2rem" }}>
        <ButtonSecondaryV2 onClick={() => handleClick({dataFormat: 'csv'})}>CSV</ButtonSecondaryV2>
        <ButtonSecondaryV2 onClick={() => handleClick({dataFormat: 'json'})}>JSON</ButtonSecondaryV2>
      </div>
    </Modal>
  )
}
